import React, {memo, useEffect, useState} from 'react';
import ImageMapper from "react-image-mapper";
import DisplayIf from "../common/DisplayIf";


function importAll(r) {
    return r.keys().map(r).map(_ => _.default);
}

export const Images = {
    SBA_2020_HOME_IMGS: importAll(require.context('../../assets/animation/SBA_2020_Home', false, /\.(png|jpe?g|svg)$/))
}

const PhotoAnimation = ({images, fps, ...props}) => {
    const [curImgIndex, setCurImgIndex] = useState(0)
    const period = 1000 / fps

    useEffect(() => {
        const i = setInterval(() => setCurImgIndex(ind => (ind + 1) % images.length), period)
        return () => clearInterval(i)
    }, [images])


    return (<>{images.map((i, ind) => (
        <DisplayIf key={''+ind} condition={ind === curImgIndex}>
            <div>
                <ImageMapper
                    src={i}
                    style={{marginTop: -60}}
                    imgWidth={1280}
                    {...props}
                />
            </div>
        </DisplayIf>
    ))}</>)
}

export default PhotoAnimation